<template>
	<div id="reprintPosTicket" align="center" v-show="false">
		<table border="0" width="450">
			<tr>
				<td align="center" colspan="3">
					<!-- <div class="txt1" style="padding-top: 5mm">
						JOSE LUIS POZOS GUTIERREZ<br>
						POGL810405IN6
					</div> -->
					<div class="txt1" style="padding-top: 5mm">RLS</div>
					<div class="txt2">Servicios de Mantenimiento</div>
					<!-- <div class="txt2">
						Av. Nezahualcóyotl #390<br />
						Col. Agua Azul<br />
						Nezahualcóyotl, Estado de México<br />
						C.P 57500
					</div>
					<div class="txt3">Tel. 55 6382 5173 || Email: atc@s2r.mx</div>
					<div class="txt3">=========================================</div> -->
				</td>
			</tr>
			<tr>
				<td width="33%" align="center" class="txt2">
					<b>Ticket</b>
				</td>
				<td width="33%" align="center" class="txt2">
					<b>Fecha</b>
				</td>
				<td width="33%" align="center" class="txt2">
					<b>Hora</b>
				</td>
			</tr>
			<tr>
				<td width="33%" align="center" class="txt3">#{{ ticketData.id }}</td>
				<td width="33%" align="center" class="txt3">{{ moment(ticketData.created_at).format('YYYY-MM-DD') }}</td>
				<td width="33%" align="center" class="txt3">{{ moment(ticketData.created_at).format('HH:mm:ss') }} hrs</td>
			</tr>
			<tr>
				<td v-if="serviceOrder > 0" align="center" class="txt2">{{ serviceOrder }}</td>
			</tr>
			<tr>
				<td align="center" colspan="3">
					<div class="txt3">=========================================</div>
				</td>
			</tr>
		</table>
		<table border="0" width="450">
			<tr v-for="(record, index) in cart" :key="index">
				<td align="left" class="txt3 p07">
					{{ record.label }}
					<br />
					<small><b>SKU</b>: {{ record.product.sku | replaceIfLogicalFalse('-') }}</small>
					<span v-if="!hasGiftTicket">
						<small v-if="record.wc_discount">
							<br />
							<b>Promoción</b>: -{{ record.wc_discount }}%
						</small>
						<br />
						<div v-if="record.wc_discount">
							<span style="text-decoration: line-through">{{ numeral(getPrice(record.product.prices)).format('$0,0.00') }}</span>
							<span> | {{ record.sale_price_label }}</span>
						</div>
						<b v-else>{{ record.amount_label }}</b>
					</span>
				</td>
			</tr>
		</table>
		<table border="0" width="450" v-if="!hasGiftTicket">
			<tr v-if="!orderDiscount">
				<td align="right" class="txt3 p07"><b>Total:</b> {{ numeral(total).format('$0,0.00') }}</td>
			</tr>
			<tr v-else>
				<td align="right" class="txt3 p07"><b>Subtotal:</b> {{ numeral(total).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="orderDiscount">
				<td align="right" class="txt3 p07"><b>Descuento:</b> {{ numeral(orderDiscount).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="orderDiscount">
				<td align="right" class="txt3 p07"><b>Total:</b> {{ numeral(total - orderDiscount).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="totalAdvances > 0">
				<td align="right" class="txt3 p07"><b>Anticipo:</b> {{ numeral(totalAdvances).format('$0,0.00') }}</td>
			</tr>
			<tr>
				<td align="center" class="txt2 pt10">
					<b>=== Formas de Pago ===</b>
				</td>
			</tr>
			<tr v-if="numeral(paymentData.payment_cash).value() > 0">
				<td align="right" class="txt3 p07"><b>Efectivo:</b> {{ numeral(paymentData.payment_cash).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="numeral(paymentData.payment_bank_terminal).value() > 0 || numeral(paymentData.payment_billpocket).value() > 0">
				<td align="right" class="txt3 p07"><b>Tarjetas:</b> {{ numeral(numeral(paymentData.payment_bank_terminal).value() + numeral(paymentData.payment_billpocket).value()).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="numeral(paymentData.payment_transfer).value() > 0">
				<td align="right" class="txt3 p07"><b>Transferencia:</b> {{ numeral(paymentData.payment_transfer).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="numeral(paymentData.payment_paypal).value() > 0">
				<td align="right" class="txt3 p07"><b>PayPal:</b> {{ numeral(paymentData.payment_paypal).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="numeral(paymentData.payment_mercadopago).value() > 0">
				<td align="right" class="txt3 p07"><b>MercadoPago:</b> {{ numeral(paymentData.payment_mercadopago).format('$0,0.00') }}</td>
			</tr>
			<tr v-if="numeral(paymentData.payment_aplazo).value() > 0">
				<td align="right" class="txt3 p07"><b>Aplazo:</b> {{ numeral(paymentData.payment_aplazo).format('$0,0.00') }}</td>
			</tr>
			<!-- <tr>
				<td align="right" class="txt3 p07"><b>Cambio:</b> {{ numeral(paymentData.payment_change).format('$0,0.00') }}</td>
			</tr> -->
			<tr v-if="setAdvance" class="txt2 pt10">
				<td align="center" class="txt3 p07">
					<b>*** ESTE COBRO ES UN ANTICIPO ***</b>
				</td>
			</tr>
		</table>
		<table border="0" width="450" v-if="!hasGiftTicket">
			<tr>
				<td align="center">
					<div class="txt3">=========================================</div>
				</td>
			</tr>
			<tr>
				<td align="center" class="txt2">
					<b>=== Cliente ===</b>
				</td>
			</tr>
		</table>
		<table border="0" width="450" v-if="hasGiftTicket">
			<tr>
				<td align="center">
					<div class="txt3">=========================================</div>
				</td>
			</tr>
			<tr class="txt2 pt10">
				<td align="center" class="txt3 p07">
					<b>*** TICKET DE REGALO ***</b>
				</td>
			</tr>
		</table>
		<table border="0" width="450" v-if="hasClient && !hasGiftTicket">
			<tr>
				<td align="left" class="txt3 p07">
					<b>Nombre:</b> {{ `${client.client_name} ${client.client_surname}` }} {{ client.client_last_surname | replaceIfLogicalFalse('') }}<br />
					<b>Email:</b> {{ client.email | replaceIfLogicalFalse('- No establecido -') }}<br />
					<b>Teléfono de contacto:</b> {{ client.primary_phone }}
				</td>
			</tr>
		</table>
		<table border="0" width="450" v-else-if="!hasGiftTicket">
			<tr>
				<td align="center" class="txt3">Público en General</td>
			</tr>
		</table>
		<table border="0" width="450" v-if="!setAdvance && !hasGiftTicket">
			<tr>
				<td align="center" class="p07">
					<br />
					<b class="txt2">=== Facturación ===</b><br />
					<div class="txt3">
						Recuerda que tienes hasta el último día del mes para generar tu factura y podrás hacerlo en sucursal con ticket de compra vigente del mes en curso y los datos fiscales con respecto a la
						versión 4.0 del uso de CFDI o a través de nuestra página web: <b>https://facturacion.rls.com.mx</b> con los siguientes datos:
						<br />
						<br />
						<b>Ticket:</b> {{ ticketData.id }} <br />
						<b>Validador:</b> {{ ticketData.validator }}
					</div>
				</td>
			</tr>
		</table>
		<table border="0" width="450">
			<tr>
				<td align="center">
					<div class="txt3">=========================================</div>
				</td>
			</tr>
			<tr>
				<td align="center" class="txt3 p07">Agradecemos tu preferencia.</td>
			</tr>
			<tr>
				<td align="center" class="txt3 p07">Consulta nuestro aviso de privacidad en <b>https://s2r.mx/aviso-de-privacidad</b></td>
			</tr>
			<tr>
				<td align="center" class="txt3 p07">
					Nuestros productos y servicios cuentan con 30 días de garantía en tienda.
					<br />
					Aplican restricciones
					<br />
					Consúltalo en <b>https://s2r.mx/garantias</b>
				</td>
			</tr>
		</table>
		<table border="0" width="450">
			<tr>
				<td align="center">
					<div class="txt3">=========================================</div>
				</td>
			</tr>
			<tr>
				<td align="center" class="txt3 p07">
					<span> Ayúdanos a mejorar respondiendo a una breve encuesta ingresando a <b>https://s2r.mx/encuestas/servicio</b> o bien, escaneando el siguiente código QR: </span>
				</td>
			</tr>
			<tr>
				<td align="center" style="padding: 5mm 0">
					<qr-code :size="150" text="https://s2r.mx/encuestas/servicio"></qr-code>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import Vue from 'vue'
import numeral from 'numeral'
import moment from 'moment'
import VueHtmlToPaper from 'vue-html-to-paper'
import qrCode from 'vue-qr-generator'
import utilities from '@/services/utilities'

const options = {
	name: '_blank',
	specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
	styles: ['resources/css/printTickets.css'],
	timeout: 1000, // default timeout before the print window appears
	autoClose: true, // if false, the window will not close after printing
	windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, options)

export default {
	name: 'ticketComponent',
	components: {
		qrCode,
	},
	props: {
		ticketData: {
			type: Object,
			default: () => {},
		},
		theSalesman: {
			type: String,
			default: '',
		},
		serviceOrder: {
			type: Number,
			default: 0,
		},
		orderDiscount: {
			type: Number,
			default: 0,
		},
		cart: {
			type: Array,
			default: () => [],
		},
		paymentData: {
			type: Object,
			default: () => {},
		},
		setAdvance: {
			type: Boolean,
			default: false,
		},
		advances: {
			type: Array,
			default: () => [],
		},
		client: {
			type: Object,
			default: () => {},
		},
		hasGiftTicket: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		totalAdvances() {
			if (this.advances.length > 0) {
				let total = 0
				this.advances.forEach((element) => {
					total += element.total
				})
				return total
			}
			return 0
		},
		hasClient() {
			return !!utilities.objectValidate(this.client, 'client_name', false)
		},
		total() {
			let summ = 0
			this.cart.forEach((e) => {
				summ += e.amount
			})
			return summ
		},
		totalProducts() {
			let summ = 0
			this.cart.forEach((e) => {
				summ += numeral(e.quantity).value()
			})
			return numeral(summ).value()
		},
	},
	methods: {
		numeral,
		moment,
		getPrice(string) {
			if (!string) {
				return 0
			}
			return JSON.parse(string).sale_price
		},
	},
}
</script>
